<script lang="ts">
  import type { PlaceType } from "../../../types";
  import AppBar from "../../../components/app-bar.svelte";
  import Icon from "../../../components/icon.svelte";
  import ScheduleGroups from "../../../components/place-types/schedule-groups.svelte";
  import { getPlaces, hasPlaces } from "../../../domain/place-types";
  import { getNow } from "../../../data/clock";

  export let data;
  export let time = getNow();

  $: placeType = data.placeType;
  $: places = data.places;
  $: children = data.children.filter((child: PlaceType) => hasPlaces(child, places, $time));
  $: placeHoursGroups = data.placeHoursGroups;
</script>

<AppBar title={placeType.label} returnLink="/places" />

<main>
  {#if hasPlaces(placeType, places, $time)}
    <section class="LinkGroup">
      <ScheduleGroups
        places={getPlaces(placeType, places, $time)}
        {placeHoursGroups}
        showSubtitle={placeType.showPlaceParents}
      />
    </section>
  {:else if children.length == 0}
    <section class="LinkGroup">
      <p>No locations found for <b>&ldquo;{placeType.label}&rdquo;</b></p>
    </section>
  {/if}

  {#each children as child}
    <section class="LinkGroup">
      <header class="GroupHeader">
        <h2 class="GroupTitle type-h3">
          {#if child.iconSrc}
            <Icon src={child.iconSrc} fill={child.iconColor} size={24} />
          {/if}
          {child.label}
        </h2>

        {#if child.note}
          <p class="Note type-caption">
            {child.note}
          </p>
        {/if}
      </header>

      <ScheduleGroups
        places={getPlaces(child, places, $time)}
        {placeHoursGroups}
        showSubtitle={placeType.showPlaceParents}
      />
    </section>
  {/each}
</main>

<style>
  main {
    flex: 1 1 auto;
    hyphens: auto;
    overflow: auto;
    width: 100%;
  }

  .LinkGroup {
    box-shadow: 0 -1px 0 0 var(--color-tooling);
    flex-wrap: wrap;
    margin-block: 0;
    margin-left: max(env(safe-area-inset-left), var(--outer-padding));
    margin-right: max(env(safe-area-inset-right), var(--outer-padding));
    padding: var(--outer-padding) 0;
    text-decoration: none;
  }

  .LinkGroup:first-child {
    border-top: 0;
  }

  .GroupTitle {
    align-items: center;
    display: flex;
    line-height: 28px;
  }

  .GroupTitle :global(svg) {
    flex-shrink: 0;
    margin-right: 8px;
    margin-left: -2px;
  }

  .GroupHeader:not(:last-child) {
    margin-bottom: 16px;
  }

  .Note {
    margin: calc(var(--sp) * 4) 0 0;
  }
</style>
